import { useFormContext } from "react-hook-form";
import { TaxDetails } from "../../../../../../../../components/taxDetails/TaxDetails";
import { TaxDetailsFormKeyProps } from "../../../../../../../../components/taxDetails/modelsAndSchemas/Models";
import { CURRENCY_FORMAT_MAP } from "../../../../../../../../components/textFieldCurrency/CurrencyUtils";
import { useForceUpdate } from "../../../../../../../../hooks/useForceUpdate";
import { ProjectAddOrEditExpenseOrFeeFormKey } from "../../../../../../modelsAndSchemas/Models";

interface ProjectAddFeesOrExpenseTaxDetails {
  isEditable?: boolean;
}

export const pageId = "projectAddFeesAndExpenseTaxForm";

export const ProjectAddFeesAndExpenseTaxForm = ({
  isEditable = true,
}: ProjectAddFeesOrExpenseTaxDetails) => {
  const { getValues } = useFormContext();
  const forceUpdate = useForceUpdate();

  const {
    billingCurrency: billingCurrencyId,
    billingCurrencyName,
    billingAmount,
  } = getValues();
  const billingCurrencyFormat = CURRENCY_FORMAT_MAP[billingCurrencyName];

  const taxDetailsFormKeys: TaxDetailsFormKeyProps = {
    programFeeKey:
      ProjectAddOrEditExpenseOrFeeFormKey.projectFeeOrExpenseAmount,
    taxKey: ProjectAddOrEditExpenseOrFeeFormKey.projectTax,
    taxPercentageKey: ProjectAddOrEditExpenseOrFeeFormKey.projectTaxPercentage,
    taxAmountWithFormatKey:
      ProjectAddOrEditExpenseOrFeeFormKey.projectTaxAmountWithFormat,
    taxAmountKey: ProjectAddOrEditExpenseOrFeeFormKey.projectTaxAmount,
    taxEntriesKey: ProjectAddOrEditExpenseOrFeeFormKey.projectTaxEntries,
    taxSearchKey: ProjectAddOrEditExpenseOrFeeFormKey.projectTaxSearch,
  };

  return (
    <TaxDetails
      pageId={pageId}
      currencyFormat={billingCurrencyFormat}
      currencyName={billingCurrencyName}
      forceUpdate={forceUpdate}
      currencyId={billingCurrencyId}
      isInEditMode={isEditable}
      taxDetailsFormKeys={taxDetailsFormKeys}
      programOrProjectFee={billingAmount}
    />
  );
};
